































































































































































































































































































import {
	computed,
	defineComponent,
	onMounted,
	PropType,
	Ref,
	ref,
	watch,
} from '@vue/composition-api';
import addDays from 'date-fns/addDays';
import parse from 'date-fns/parse';
import startOfDay from 'date-fns/startOfDay';
import {
	addMonths,
	addYears,
	startOfMonth,
	startOfYear,
	sub,
} from 'date-fns';
import ActiveMembersReport from '@front-app/views/csr/communityReports/ActiveMembersReport.vue';
import AddRolesPanel from '@front-app/views/csr/communityReports/AddRolesPanel.vue';
import AllMemberListingReport from '@front-app/views/csr/communityReports/AllMemberListingReport.vue';
import ButtonList from '@front-app/components/dropdowns/ButtonList.vue';
import ChevronIcon from '@front-app/components/icons-old/ChevronDown.vue';
import CheckboxList from '@front-app/components/inputs/CheckboxList.vue';
import ContentInteractionsReport from '@front-app/views/csr/communityReports/ContentInteractionsReport.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import DiscussionPostsReport from '@front-app/views/csr/communityReports/DiscussionPostsReport.vue';
import DiscussionTopicsReport from '@front-app/views/csr/communityReports/DiscussionTopicsReport.vue';
import DiscussionViewsReport from '@front-app/views/csr/communityReports/DiscussionViewsReport.vue';
import EngagementReport from '@front-app/views/csr/communityReports/EngagementReport.vue';
import EventReport from '@front-app/views/csr/communityReports/EventReport.vue';
import FileAndLinkSharesReport from '@front-app/views/csr/communityReports/FileAndLinkSharesReport.vue';
import FileDownloadsReport from '@front-app/views/csr/communityReports/FileDownloadsReport.vue';
import GroupMemberListingReport from '@front-app/views/csr/communityReports/GroupMemberListingReport.vue';
import GroupRoleChangePanel from '@front-app/views/csr/communityReports/GroupRoleChangePanel.vue';
import PublicLink from '@front-app/components/buttons/PublicLink.vue';
import RadioList from '@front-app/components/inputs/RadioList.vue';
import SimpleDropdown from '@front-app/components/dropdowns/SimpleDropdown.vue';
import TimePicker from '@front-app/components/TimePicker.vue';
import TotalMembersReport from '@front-app/views/csr/communityReports/TotalMembersReport.vue';
import UserVerificationPanel from '@front-app/views/csr/communityReports/UserVerificationPanel.vue';
import { BannerAction, UserAction } from '@front-app/services/ActionApi/UserActionRequestModel';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { DropdownPosition } from '@front-app/components/dropdowns/dropdownPosition';
import { GroupsStore } from '@front-app/store/singletons/Groups';
import { EventsStore } from '@front-app/store/singletons/Events';
import {
	REPORT_TYPE,
	CommunityReport,
	GroupsListItem,
	GroupsListType,
	fetchAllGroupsList,
	NetworkSearchUser,
} from '@front-app/services/CommunityApi/CommunityReportsApi';
import { Size } from '@front-app/components/constants';
import { TIME_RANGE } from '@front-app/util/time';
import { toDatetimeLocal } from '@front-app/util/format';
import { useCheckboxes } from '@front-app/hooks/useCheckboxes';

const AVAILABLE_REPORTS: CommunityReport[] = [
	{
		key: REPORT_TYPE.ALL_MEMBER_LISTING,
		label: 'csr.community-queries.reports.network-user-search',
	},
	{
		key: REPORT_TYPE.GROUP_MEMBER_LISTING,
		label: 'csr.community-queries.reports.group-member-listing',
	},
	{
		key: REPORT_TYPE.EVENT_MEMBER_LISTING,
		label: 'csr.community-queries.reports.event-attendees',
	},
	{
		key: REPORT_TYPE.EVENT_BANNERS_REPORT,
		label: 'csr.community-queries.reports.event-banners-report',
	},
	{
		key: REPORT_TYPE.ENGAGEMENT_REPORT,
		label: 'csr.community-queries.reports.engagement-report',
	},
	{
		key: REPORT_TYPE.TOTAL_MEMBERS,
		label: 'csr.community-queries.reports.total-members',
	},
	{
		key: REPORT_TYPE.ACTIVE_MEMBERS,
		label: 'csr.community-queries.reports.active-members',
	},
	{
		key: REPORT_TYPE.CONTENT_INTERACTIONS,
		label: 'csr.community-queries.reports.content-interactions',
	},
	{
		key: REPORT_TYPE.DISCUSSION_TOPICS,
		label: 'csr.community-queries.reports.new-discussion-topics',
	},
	{
		key: REPORT_TYPE.DISCUSSION_POSTS,
		label: 'csr.community-queries.reports.new-discussion-posts',
	},
	{
		key: REPORT_TYPE.DISCUSSION_VIEWS,
		label: 'csr.community-queries.reports.discussion-views',
	},
	{
		key: REPORT_TYPE.FILE_AND_LINK_SHARES,
		label: 'csr.community-queries.reports.file-and-link-shares',
	},
	{
		key: REPORT_TYPE.FILE_DOWNLOADS,
		label: 'csr.community-queries.reports.shared-file-downloads',
	},
];

const GROUPS_LIST_TYPE_OPTIONS: GroupsListType[] = [
	GroupsListType.JOINED,
	GroupsListType.ACTIVE,
	GroupsListType.ALL,
];

const GROUPS_LIST_TYPE_OPTION_LABELS: Record<GroupsListType, string> = {
	[GroupsListType.JOINED]: 'csr.community-queries.joined-groups',
	[GroupsListType.ACTIVE]: 'csr.community-queries.active-groups',
	[GroupsListType.ALL]: 'csr.community-queries.all-groups',
};

const TIME_RANGE_OPTIONS = [
	{
		key: TIME_RANGE.LAST_30_DAYS,
		label: 'data-range.last-30-days',
	},
	{
		key: TIME_RANGE.LAST_90_DAYS,
		label: 'data-range.last-90-days',
	},
	{
		key: TIME_RANGE.LAST_1_MONTH,
		label: 'data-range.last-1-month',
	},
	{
		key: TIME_RANGE.LAST_3_MONTHS,
		label: 'data-range.last-3-months',
	},
	{
		key: TIME_RANGE.LAST_12_MONTHS,
		label: 'data-range.last-12-months',
	},
	{
		key: TIME_RANGE.LAST_YEAR,
		label: 'data-range.last-year',
	},
];

export default defineComponent({
	components: {
		ActiveMembersReport,
		AllMemberListingReport,
		AddRolesPanel,
		ButtonList,
		ChevronIcon,
		CheckboxList,
		ContentInteractionsReport,
		CtaButton,
		DiscussionPostsReport,
		DiscussionTopicsReport,
		DiscussionViewsReport,
		EngagementReport,
		EventReport,
		FileAndLinkSharesReport,
		FileDownloadsReport,
		GroupMemberListingReport,
		GroupRoleChangePanel,
		PublicLink,
		RadioList,
		SimpleDropdown,
		TimePicker,
		TotalMembersReport,
		UserVerificationPanel,
	},
	props: {
		eventId: {
			type: String,
			required: false,
			default: '',
		},
		fromDate: {
			type: Date,
			required: false,
			default: () => sub(new Date(), { days: 30 }),
		},
		toDate: {
			type: Date,
			required: false,
			default: () => new Date(),
		},
		action: {
			type: String as PropType<BannerAction>,
			required: false,
			default: UserAction.BANNER_VIEW,
		},
	},
	setup(props, ctx) {
		// Select report dropdown
		const isReportsMenuOpen = ref(false);
		const selectedReport: Ref<CommunityReport> = ref({
			key: REPORT_TYPE.GROUP_MEMBER_LISTING,
			label: `${ctx.root.$t('csr.community-queries.reports.group-member-listing')}`,
		});
		const selectReport = (report: CommunityReport) => {
			selectedReport.value = report;
			isReportsMenuOpen.value = false;
		};

		// Select groups dropdown
		const groupsListTypeOptions = GROUPS_LIST_TYPE_OPTIONS.map((key) => ({
			key,
			label: ctx.root.$t(GROUPS_LIST_TYPE_OPTION_LABELS[key]) as unknown as string,
		}));
		const selectedGroupsListType = ref(GroupsListType.JOINED);
		const groupsStore = GroupsStore.getInstance();
		const joinedGroupsList = computed(() => groupsStore.groups.value);
		const activeGroupsList = ref([] as GroupsListItem[]);
		const allGroupsList = ref([] as GroupsListItem[]);
		onMounted(async () => {
			groupsStore.fetchGroupsOnce();
			activeGroupsList.value = await fetchAllGroupsList(GroupsListType.ACTIVE);
			allGroupsList.value = await fetchAllGroupsList(GroupsListType.ALL);
		});
		const groupsIds = computed(() => {
			if (selectedGroupsListType.value === GroupsListType.JOINED) {
				return joinedGroupsList.value.map((group) => group.id);
			}
			if (selectedGroupsListType.value === GroupsListType.ACTIVE) {
				return activeGroupsList.value.map((group) => group.groupId);
			}
			return allGroupsList.value.map((group) => group.groupId);
		});

		const groupCheckboxes = useCheckboxes(ctx, {
			choiceKeys: computed(() => (groupsIds.value || [])),
			initialChoices: computed(() => []),
			labelFn: (groupId: string) => {
				if (selectedGroupsListType.value === GroupsListType.JOINED) {
					return groupsStore.groupById(groupId)?.name || '';
				}
				if (selectedGroupsListType.value === GroupsListType.ACTIVE) {
					return activeGroupsList.value.find((group) => group.groupId === groupId)?.groupName || '';
				}
				return allGroupsList.value.find((group) => group.groupId === groupId)?.groupName || '';
			},
		});
		watch(selectedGroupsListType, (curr: GroupsListType, prev: GroupsListType) => {
			if (curr !== prev) {
				groupCheckboxes.selectedChoices.value = [];
			}
		});
		const groupSelectOptions = groupCheckboxes.choices;
		const selectedGroupIds = groupCheckboxes.selectedChoices;
		const toggleGroup = (id: string) => {
			groupCheckboxes.toggle(id);
			// Scroll to the top of the page as it scrolls to the bottom of the long groups list otherwise
			window.scrollTo(0, 0);
		};

		// Select events dropdown
		const eventsStore = EventsStore.getInstance();
		onMounted(() => eventsStore.getEventsOnce());
		const eventsList = computed(() => eventsStore.events.value);
		const eventIds = computed(() => eventsList.value.map((event) => event.id));

		const eventCheckboxes = useCheckboxes(ctx, {
			choiceKeys: computed(() => (eventIds.value || [])),
			initialChoices: computed(() => []),
			labelFn: (eventId: string) => (eventsStore.eventById(eventId)?.name || ''),
		});
		const eventSelectOptions = eventCheckboxes.choices;
		const selectedEvents = eventCheckboxes.selectedChoices;
		const toggleEvent = (id: string) => {
			eventCheckboxes.toggle(id);
		};

		// Time selection
		const timeFrom = ref(toDatetimeLocal(startOfDay(addDays(Date.now(), -30))));
		const timeUntil = ref(toDatetimeLocal(startOfDay(Date.now())));
		const formatTime = (time: string) => parse(time, "yyyy-MM-dd'T'HH:mm", new Date());
		const isTimeRangeMenuOpen = ref(false);
		const setTimeRange = (option: TIME_RANGE) => {
			switch (option) {
			case TIME_RANGE.LAST_30_DAYS:
				timeFrom.value = toDatetimeLocal(startOfDay(addDays(Date.now(), -30)));
				timeUntil.value = toDatetimeLocal(startOfDay(Date.now()));
				break;
			case TIME_RANGE.LAST_90_DAYS:
				timeFrom.value = toDatetimeLocal(startOfDay(addDays(Date.now(), -90)));
				timeUntil.value = toDatetimeLocal(startOfDay(Date.now()));
				break;
			case TIME_RANGE.LAST_1_MONTH:
				timeFrom.value = toDatetimeLocal(startOfMonth(addMonths(Date.now(), -1)));
				timeUntil.value = toDatetimeLocal(startOfMonth(Date.now()));
				break;
			case TIME_RANGE.LAST_3_MONTHS:
				timeFrom.value = toDatetimeLocal(startOfMonth(addMonths(Date.now(), -3)));
				timeUntil.value = toDatetimeLocal(startOfMonth(Date.now()));
				break;
			case TIME_RANGE.LAST_12_MONTHS:
				timeFrom.value = toDatetimeLocal(startOfMonth(addMonths(Date.now(), -12)));
				timeUntil.value = toDatetimeLocal(startOfMonth(Date.now()));
				break;
			case TIME_RANGE.LAST_YEAR:
				timeFrom.value = toDatetimeLocal(startOfYear(addYears(Date.now(), -1)));
				timeUntil.value = toDatetimeLocal(startOfYear(Date.now()));
				break;
			default:
				throw new Error(`Unhandled time range case: ${option}`);
			}
		};

		// Group role change, user verification and adding roles
		const isGroupRoleChangePanelOpen = ref(false);
		const isUserVerificationPanelOpen = ref(false);
		const isAddRolesPanelOpen = ref(false);
		const selectedUserIds = ref([] as string[]);
		const selectedGroups = ref([] as GroupsListItem[]);

		const openGroupRoleChangePanel = (userIds: string[]) => {
			selectedUserIds.value = userIds;
			selectedGroups.value = selectedGroupIds.value.map((groupId: string) => {
				let groupName = '';
				if (selectedGroupsListType.value === GroupsListType.JOINED) {
					groupName = groupsStore.groupById(groupId)?.name || '';
				}
				if (selectedGroupsListType.value === GroupsListType.ACTIVE) {
					groupName = activeGroupsList.value.find((group) => group.groupId === groupId)?.groupName || '';
				}
				if (selectedGroupsListType.value === GroupsListType.ALL) {
					groupName = allGroupsList.value.find((group) => group.groupId === groupId)?.groupName || '';
				}
				return {
					groupId,
					groupName,
				};
			});
			isGroupRoleChangePanelOpen.value = true;
		};
		const openGroupRoleChangePanelForSingleUser = (user: NetworkSearchUser) => {
			selectedUserIds.value = [user.id];
			selectedGroups.value = user.groups.map((group) => ({
				groupId: group.groupId,
				groupName: group.groupName,
			}));
			isGroupRoleChangePanelOpen.value = true;
		};
		const closeGroupRoleChangePanel = () => {
			isGroupRoleChangePanelOpen.value = false;
		};
		const openUserVerificationPanel = (userIds: string[]) => {
			selectedUserIds.value = userIds;
			isUserVerificationPanelOpen.value = true;
		};
		const closeUserVerificationPanel = () => {
			isUserVerificationPanelOpen.value = false;
		};
		const openAddRolesPanel = (userIds: string[]) => {
			selectedUserIds.value = userIds;
			isAddRolesPanelOpen.value = true;
		};
		const closeAddRolesPanel = () => {
			isAddRolesPanelOpen.value = false;
		};

		return {
			REPORT_TYPE,
			AVAILABLE_REPORTS,
			isReportsMenuOpen,
			selectedReport,
			selectReport,
			// Select groups
			groupSelectOptions,
			selectedGroupIds,
			selectedGroups,
			toggleGroup,
			groupsListTypeOptions,
			selectedGroupsListType,
			GROUPS_LIST_TYPE_OPTION_LABELS,
			// Select events
			eventSelectOptions,
			selectedEvents,
			toggleEvent,
			// Timepickers
			timeFrom,
			timeUntil,
			isTimeRangeMenuOpen,
			TIME_RANGE_OPTIONS,
			setTimeRange,
			// Group role change, user verification and adding roles
			isGroupRoleChangePanelOpen,
			isUserVerificationPanelOpen,
			isAddRolesPanelOpen,
			selectedUserIds,
			openGroupRoleChangePanel,
			openGroupRoleChangePanelForSingleUser,
			closeGroupRoleChangePanel,
			openUserVerificationPanel,
			closeUserVerificationPanel,
			openAddRolesPanel,
			closeAddRolesPanel,
			// Util
			formatTime,
			ButtonPalettes,
			DropdownPosition,
			Size,
		};
	},
});
